import {Box, Flex, Heading, Icon, Text} from '@chakra-ui/react';
import {IconCheck} from '@tabler/icons';
import React from 'react';
import Image from 'next/image';

export const BenefitsSection: React.FC = () => {
  return (
    <Flex
      maxW="1120px"
      width="100%"
      margin="0 auto"
      pt={{base: '30px', md: '90px'}}
      pb={{base: '30px', md: '40px'}}
      px={{base: '20px', md: 0}}
      flexDirection={{base: 'column', md: 'row'}}
      color="white"
    >
      <Box maxW="644px" mr={{base: '0', md: '44px'}}>
        <Heading size="xl" fontWeight="600" mb={{base: '20px', md: '40px'}}>
          Become a collector and unlock the benefits of fractional ownership
        </Heading>
        <Box>
          <Flex
            flexDirection="row"
            alignItems="center"
            mb={{base: '20px', md: '24px'}}
          >
            <Icon as={IconCheck} height="20px" width="20px" mr="20px" />
            <Text>
              Own a ‘piece’ of the artwork - legal beneficial ownership of the
              item (not a literal physical piece in the post!).
            </Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            mb={{base: '20px', md: '24px'}}
          >
            <Icon as={IconCheck} height="20px" width="20px" mr="20px" />
            <Text>
              Play a pivotal role in keeping the item on public display for all
              to enjoy.
            </Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            mb={{base: '20px', md: '24px'}}
          >
            <Icon as={IconCheck} height="20px" width="20px" mr="20px" />
            <Text>You will always have a say in the item’s future.</Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            mb={{base: '20px', md: '24px'}}
          >
            <Icon as={IconCheck} height="20px" width="20px" mr="20px" />
            <Text>
              Receive digital benefits, ongoing content and access to the
              artwork.
            </Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            mb={{base: '20px', md: '24px'}}
          >
            <Icon as={IconCheck} height="20px" width="20px" mr="20px" />
            <Text>
              Gain access to exclusive art and merchandise inspired by the
              piece.
            </Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            mb={{base: '20px', md: '24px'}}
          >
            <Icon as={IconCheck} height="20px" width="20px" mr="20px" />
            <Text>
              You are making a big contribution to supporting incredible
              charities fighting domestic violence and supporting survivors.
            </Text>
          </Flex>
        </Box>
      </Box>
      <Flex justifyContent="center">
        <Box>
          <Image
            src="/assets/banksy/banksy-benefits.png"
            height="377px"
            width="355px"
          />
        </Box>
      </Flex>
    </Flex>
  );
};
